export enum UserMonitorConnectionStatus {
  Invited = 'Invited',
  Confirmed = 'Confirmed',
}
